<template>
  <b-row>
    <b-col class="mb-2">
      <b-button
        pill
        variant="primary"
        @click="getMarketplaceProductIntegrations()"
        title="Recarregar produtos"
      >
        <i class="fas fa-sync"></i>
      </b-button>
    </b-col>
    <b-col cols="12">
      <b-table
        striped
        hover
        show-empty
        empty-text="Sem produtos integrados ao Mercado Livre"
        :fields="table.headers"
        :items="productsIntegrated"
        :busy="loading"
      >
        <template #cell(updatedAt)="{ item }">
          <span v-if="item.status !== ProductIntegrationStatus.NOT_STARTED">{{
            item.updatedAt
              ? new Date(item.updatedAt).toLocaleString('pt-BR')
              : ''
          }}</span>
        </template>
        <template #cell(status)="{ item }">
          <span>{{ getText(item.status) }}</span>
        </template>
        <template #cell(actions)="{ item }">
          <div class="d-flex align-items-center" style="gap: 0.8rem">
            <b-button
              v-if="item.status === ProductIntegrationStatus.ERROR"
              size="sm"
              variant="danger"
              title="Ver erros"
              @click="
                $refs.integrationErrorModal.open(
                  item.product.produto,
                  item.errorPayload,
                  item.payload
                )
              "
            >
              <i class="fas fa-eye"></i>
            </b-button>
            <b-button
              v-if="item.status === ProductIntegrationStatus.ERROR"
              size="sm"
              variant="warning"
              title="Integrar novamente"
              @click="$refs.reintegrationModal.open(item)"
            >
              <i class="fas fa-box-open"></i>
            </b-button>
          </div>
        </template>
      </b-table>
    </b-col>
    <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <slot name="pagination">
        <b-pagination
          v-model="pagination.currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.itemsPerPage"
          :disabled="loading"
        ></b-pagination>
      </slot>
    </b-col>

    <IntegrationErrorModal ref="integrationErrorModal" />
    <ReintegrationModal
      ref="reintegrationModal"
      @reintegrated="getMarketplaceProductIntegrations"
    />
  </b-row>
</template>

<script>
import ProductIntegrationStatus, {
  getText,
} from 'Enums/Integration/Marketplace/ProductIntegrationStatus.js';
import { mapState } from 'vuex';
import shopkeeperAppApi from '@/api/shopkeeperAppApi';

import IntegrationErrorModal from './IntegrationErrorModal.vue';
import ReintegrationModal from './ReintegrationModal.vue';

export default {
  name: 'ListProductIntegrationsMercadoLivre',
  props: {
    marketplace: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ProductIntegrationStatus,
      productsIntegrated: [],
      loading: false,
      pagination: {
        currentPage: 1,
        itemsPerPage: 10,
        total: 0,
        lastPage: 0,
      },
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'product.produto',
            label: 'Produto',
            sortable: true,
          },
          {
            key: 'status',
            label: 'Status',
          },
          {
            key: 'updatedAt',
            label: 'Integrado em',
            sortable: true,
          },
          {
            key: 'actions',
            label: 'Ações',
            sortable: false,
            thStyle: 'width: 80px',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  watch: {
    'pagination.currentPage': function () {
      this.getMarketplaceProductIntegrations();
    },
    'marketplace.id': function () {
      if (!this.marketplace.id) return;

      this.pagination = {
        currentPage: 1,
        itemsPerPage: 10,
        total: 0,
        lastPage: 0,
      };
      this.productsIntegrated = [];
      this.getMarketplaceProductIntegrations();
    },
  },
  mounted() {
    this.getMarketplaceProductIntegrations();
  },
  methods: {
    getText,
    async getMarketplaceProductIntegrations() {
      this.loading = true;

      const queryParams = new URLSearchParams({
        construpUserId: this.dadosUsuario.id,
        integrationType: this.marketplace.type,
        withDetails: true,
        page: this.pagination.currentPage,
        itemsPerPage: this.pagination.itemsPerPage,
      });

      const { data } = await shopkeeperAppApi.get(
        `/integration/marketplace/products-integrations?${queryParams.toString()}`
      );

      this.loading = false;

      if (!data.data) return;

      const { items, total } = data.data;

      this.pagination.total = total;

      this.productsIntegrated = items || [];
    },
  },
  components: {
    IntegrationErrorModal,
    ReintegrationModal,
  },
};
</script>
